
import { Component, Vue, Watch } from 'vue-property-decorator'
import { State } from "vuex-class"
import User from "@/types/account/user"

@Component({
  filters: {
  },
  components: {
  }
})
export default class ColorPicker extends Vue {
  private preDefinedColor = '#E67F3E'
  private selectedColor: string | null = null

  @State((state: any) => state.user, { namespace: 'account' })
  private user!: User;

  private mounted () {
    this.selectedColor = this.getSelectedColor()
  }

  @Watch('user')
  private updateSelectedUserColor () {
    this.selectedColor = this.getSelectedColor()
  }

  private get disabled () {
    if (this.user && this.user.companyColor) {
      return this.selectedColor === this.user.companyColor
    }
    return this.selectedColor === this.preDefinedColor
  }

  private setToDefault () {
    this.selectedColor = this.getSelectedColor()
  }

  private getSelectedColor (): string {
    return (this.user && this.user.companyColor) ? this.user.companyColor : this.preDefinedColor
  }
}
